import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { Organisation } from "../../models/organisation.model";
import { NotificationDataProvider } from "../../data-provider/notification.dp";
import { PermissionCheck } from "../../shared/permission";
import { NavigationBarHelperService } from "./navigation-bar.helper";
import { SearchUtils } from "../../helper/search.helper";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { DefaultDialogs } from "../../helper/default-dialogs.helper";

let NavBarComponent = {
    selector: "vcNavBar",
    templateUrl: "/angular/components/navigation/nav.component.html",
    bindings: {
        navigateBack: "&",
        changeLiveCampaign: "&",
        user: "=",
        openProfileMenu: "&",
        profileMenuOpen: "=",
        setSelectedOrganisation: "&",
        selectedOrganisation: "=",
        switchLeaderView: "&",
        showNotificationMenu: "=",
    },
    controller: class NavBarController {
        // * bindings for typescript compiler *
        public navigateBack: any;
        public changeLiveCampaign: any;
        public user: any;
        public openProfileMenu: any;
        public profileMenuOpen: any;
        public setSelectedOrganisation: any;
        public selectedOrganisation: any;
        public switchLeaderView: any;
        public showNotificationMenu: any;
        // ************************************

        public readonly notificationDataProvider: NotificationDataProvider;
        public searchUtils: SearchUtils;
        private campaignDataProvider: CampaignDataProvider;
        public filterDataProvider: FilterDataProvider;
        public navigationBarService: NavigationBarHelperService;
        public readonly permissionProvider: PermissionCheck;
        public readonly __env: any;

        public activeCampaign: Campaign;
        public desktopSearchMode = false;
        public readonly isLeaderView: boolean;
        private readonly dialog: DialogUtils;
        private readonly defaultDialogs: DefaultDialogs;
        private readonly $scope: any;

        constructor(
            NotificationDataProvider: NotificationDataProvider,
            $scope: any,
            SearchUtils: SearchUtils,
            DialogUtils: DialogUtils,
            DefaultDialogs: DefaultDialogs,
            __app_type: string,
            CampaignDataProvider: CampaignDataProvider,
            FilterDataProvider: FilterDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            PermissionCheck: PermissionCheck,
            __env: any
        ) {
            this.notificationDataProvider = NotificationDataProvider;
            this.filterDataProvider = FilterDataProvider;
            this.searchUtils = SearchUtils;
            this.dialog = DialogUtils;
            this.$scope = $scope;
            this.campaignDataProvider = CampaignDataProvider;
            this.navigationBarService = NavigationBarHelperService;
            this.permissionProvider = PermissionCheck;
            this.isLeaderView = __app_type == "LEADER";
            this.defaultDialogs = DefaultDialogs;
            this.__env = __env;

            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.notificationDataProvider.getNotificationCount();
        }

        remainingTrialDays(): number | null {
            if (!this.activeCampaign || !this.activeCampaign.campaignexpire)
                return null;
            const campaignexpire = this.activeCampaign.campaignexpire.replace(
                /-/g,
                "/"
            );
            const campaignexpireDate = new Date(campaignexpire);
            const now = new Date();
            const difmili = now.getTime() - campaignexpireDate.getTime();
            const remaining_days =
                Math.floor(difmili / (1000 * 60 * 60 * 24)) * -1;
            if (isNaN(remaining_days) || remaining_days < 0) {
                return null;
            }
            return remaining_days;
        }

        endTrialDialog(ev: any): void {
            if (this.permissionProvider.hasStripeSubscription) {
                this.dialog.show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        conversionType: "endTrial",
                    },
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                });
            } else {
                this.defaultDialogs.contactSupport(
                    "Upgrade subscription",
                    "creating additional accounts",
                    ev
                );
            }
        }

        changeCampaign(campaign: Campaign, redirect?: string): void {
            this.changeLiveCampaign({ campaign: campaign, redirect: redirect });
        }

        setSelectedOrg(organisation: Organisation): void {
            this.setSelectedOrganisation({ organisation: organisation });
        }

        switchToLeader(organisation: Organisation): void {
            this.switchLeaderView({ organisation: organisation });
        }
    },
};

angular
    .module("navigation", ["profileMenu"])
    .component(NavBarComponent.selector, NavBarComponent);
